import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUser } from './firebase';
import {
  STATUS_FETCHING,
  STATUS_ERROR,
  STATUS_READY
} from './constants';

export const fetchUser = createAsyncThunk('fetchUser', async (nip) => await getUser(nip));

const userSlice = createSlice({
  name: 'user',
  initialState: {},
  reducers: {},
  extraReducers (builder) {
    builder
      .addCase(fetchUser.pending, (state, action) => {
        state[action.meta.arg] = {}
        state[action.meta.arg].status = STATUS_FETCHING
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state[action.meta.arg].status = STATUS_READY
        state[action.meta.arg].data = action.payload
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state[action.meta.arg].status = STATUS_ERROR
        state[action.meta.arg].error = action.error.message
      })
  }
})

export default userSlice.reducer
